import { AppLocale, appLocales, localeLabels } from '@/i18n/locales';
import { useTranslations } from 'next-intl';
import React from 'react'

const LanguageDropdown = ({
  currentLocale,
  onSwitch,
  t,
}: {
  currentLocale: string;
  onSwitch: (locale: AppLocale) => void;
  t: ReturnType<typeof useTranslations<"topbar">>;
}) => {
  return (
    <div
      className="bg-white rounded-xl shadow-lg border border-slate-100 overflow-y-auto"
      style={{ maxHeight: 320, minWidth: 160 }}
    >
      {appLocales
        .map((locale, index) => (
        <React.Fragment key={locale}>
          {index > 0 && <div className="h-px bg-gray-100 mx-3" />}
          <button
            className={`w-full h-11 text-left px-4 text-sm font-medium transition-colors duration-150 cursor-pointer ${
              currentLocale === locale
                ? "bg-blue-50 text-blue-600 font-semibold"
                : "text-[#0A2540] hover:bg-blue-50"
            }`}
            onClick={() => onSwitch(locale)}
          >
            {t(localeLabels[locale])} {currentLocale === locale ? "✓" : ""}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
}

export default LanguageDropdown;
